import { Tooltip } from "@blueprintjs/core";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import { IDataTableColumn } from "common/views/table/DataTable";
import DateLabel from "core/components/label/DateLabel";
import { Lifecycle, TestAssignment } from "../entities/TestAssignment";
import labelProvider from "../Assignment.labels";
import React from "react";
import PageLinkView from "common/views/pageLink/PageLink.view";

const { Labels } = labelProvider

export const name: IDataTableColumn<TestAssignment, any> = {
	name: "name",
	sort: "name",
	sortable: false,
	label: {k: "col.name", v: "Assignment Name"},
	component: (assignment) => {
		return (
			<span>
				{assignment.name}
			</span>
		);
	}
};

export const startDate: IDataTableColumn<TestAssignment, any> = {
	name: "startDate",
	sort: "startDate",
	sortable: false,
	label: {k: "col.startDate", v: "Start Date"},
	component: (assignment) => {
		if (!assignment.startDate) {
			return null;
		}

		return (
			<Tooltip content={<DateLabel value={assignment.startDate} />}>
				<DateLabel value={assignment.startDate}/>
			</Tooltip>
		);
	}
};

export const dueDate: IDataTableColumn<TestAssignment, any> = {
	name: "dueDate",
	sort: "dueDate",
	sortable: false,
	label: {k: "col.dueDate", v: "Due Date"},
	component: (assignment) => {
		if (!assignment.dueDate) {
			return null;
		}

		return (
			<Tooltip content={<DateLabel value={assignment.dueDate} />}>
				<DateLabel value={assignment.dueDate}/>
			</Tooltip>
		);
	}
};

export const enrollment: IDataTableColumn<TestAssignment, any> = {
	name: "enrollment",
	sort: "enrollment",
	sortable: false,
	label: {k: "col.enrollment", v: "Enrollment"},
	component: (assignment) => {
		return (
			<span>
				{`${assignment.totalCompletion}/${assignment.totalEnrollment}`}
			</span>
		);
	}
};

export const assignmentStatus: IDataTableColumn<TestAssignment, any> = {
	name: "assignmentStatus",
	sort: "assignmentStatus",
	sortable: false,
	label: {k: "col.assignmentStatus", v: "Status"},
	component: (assignment) => {
		return (
			<span>
				{Lifecycle[assignment.assignmentStatus]}
			</span>
		);
	}
};

export const actions: IDataTableColumn<TestAssignment, any> = {
	name: "actions",
	sort: "actions",
	sortable: false,
	label: {k: "col.actions", v: "Actions"},
	component: (assignment) => {
				
		return (
		
		<PageLinkView params={{assignmentId: assignment.id}} viewKey="assignment-edit-link">
			<ButtonView variant={ButtonVariant.CARD_ACTION} viewKey="assignment.edit">
				<Labels.EditAssignment />
			</ButtonView>
		</PageLinkView>
		
			
		);
	}
};




// WEBPACK FOOTER //
// ./src/panels/testAssignment/fragments/AssignmentListFragments.tsx